import React from "react";

import { AaaGameInformationSupplementaryDataType } from "../../../../models/forms";
import { ReadOnlyFormItem } from "../appInfoModelsAndHelpers";
import { ReadOnlyForm } from "../ReadOnlyForm";

type ReadOnlyAaaSupplementaryDataProps = {
  dataInForm: AaaGameInformationSupplementaryDataType;
};

const AaaSupplementaryData: Map<string, ReadOnlyFormItem> = new Map([
  [
    "devStudioExperience",
    {
      title: "titlesPreviouslyShippedByYourStudio",
      mapper: (
        data: AaaGameInformationSupplementaryDataType,
        localizedStrings: Map<string, string>
      ) =>
        data.devStudioExperience.reduce(
          (result: string[][], { platform, gameTitle, yearShipped }) => {
            if (gameTitle && platform && yearShipped) {
              result.push([
                `${localizedStrings.get("platform")}:  ${platform}`,
                `${localizedStrings.get("gameTitle")}:  ${gameTitle}`,
                `${localizedStrings.get("yearShipped")}:  ${yearShipped}`,
              ]);
            }
            return result;
          },
          []
        ),
    },
  ],
  [
    "teamMembersPreviousTitles",
    {
      title: "titlesPreviouslyShippedByYourTeamMembers",
      mapper: (
        data: AaaGameInformationSupplementaryDataType,
        localizedStrings: Map<string, string>
      ) =>
        data.teamMembersPreviousTitles.reduce(
          (result: string[][], { platform, memberName, yearShipped, gameTitle }) => {
            if (memberName && gameTitle && platform && yearShipped) {
              result.push([
                `${localizedStrings.get("teamMemberName")}:  ${memberName}`,
                `${localizedStrings.get("gameTitle")}:  ${gameTitle}`,
                `${localizedStrings.get("platform")}:  ${platform}`,
                `${localizedStrings.get("yearShipped")}:  ${yearShipped}`,
              ]);
            }
            return result;
          },
          []
        ),
    },
  ],
  [
    "competitorTitles",
    {
      mapper: (
        data: AaaGameInformationSupplementaryDataType,
        localizedStrings: Map<string, string>
      ) =>
        data.competitorTitles.reduce((result: string[][], { platform, gameTitle }) => {
          if (gameTitle && platform) {
            result.push([
              `${localizedStrings.get("gameTitle")}:  ${gameTitle}`,
              `${localizedStrings.get("platform")}:  ${platform}`,
            ]);
          }
          return result;
        }, []),
    },
  ],
]);

export const ReadOnlyAaaSupplementaryData = ({ dataInForm }: ReadOnlyAaaSupplementaryDataProps) => {
  const extraStringsToLocalize = [
    "titlesPreviouslyShippedByYourStudio",
    "platform",
    "gameTitle",
    "yearShipped",
    "teamMemberName",
  ];

  return (
    <ReadOnlyForm
      formConfig={AaaSupplementaryData}
      formData={dataInForm}
      extraStringsToLocalize={extraStringsToLocalize}
    />
  );
};
